<template>
<div class="content-class">
	<v-tabs color="black" dark slider-color="primary">
		<v-tab ripple>Utilisateurs</v-tab>
	</v-tabs>
	<pro-user-list url="proUsers">
	</pro-user-list>
</div>
</template>

<script>
import ProUserList from '../../components/proUsers/proUser.list'

export default {
	components: { ProUserList }
}
</script>

<style lang="scss">
.content-class {
    width: 100%;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/proUsers/proUser.list.vue